import { buildSchema, introspectionFromSchema, } from 'graphql';
import { DataTypeConfigU } from '../DateTypeConfig/DataTypeConfig';
import { GraphQLUtils } from '../graphql/graphql-utils';
export const schemaToIntrospection = (schemaSource) => {
    const schema = buildSchema(schemaSource, {
        assumeValid: true,
        assumeValidSDL: true,
    });
    const introspection = introspectionFromSchema(schema);
    return { introspection, schema };
};
const isInternalType = (type) => {
    return type.name.startsWith('__');
};
export const introspectionToGraphQLTypes = ({ introspection, schema, }) => {
    const types = introspection.__schema.types;
    const typesWithoutInternal = types.filter(type => !isInternalType(type));
    return {
        introspectionTypes: typesWithoutInternal,
        schema,
    };
};
const graphqlTypeToDefinition = ({ type, rootTypes, isNullable = true, isRootType = false, schema, }) => {
    if (!('kind' in type)) {
        throw new Error('Type has no kind');
    }
    const isObjectDefinition = type.kind === 'OBJECT' && 'fields' in type;
    const isListDefinition = type.kind === 'LIST' && 'ofType' in type;
    const isNonNullDefinition = type.kind === 'NON_NULL' && 'ofType' in type;
    if (!isRootType &&
        !isObjectDefinition &&
        !isListDefinition &&
        !isNonNullDefinition) {
        return {
            kind: 'TYPE_REFERENCE',
            typeName: type.name,
            isNullable,
            meta: { path: [], unmappedPath: [] },
            state: {},
            directives: [],
        };
    }
    const schemaType = schema.getType(type.name);
    const GRAPHQL_DIRECTIVES = ['join__type', 'specifiedBy'];
    const directives = schemaType?.astNode?.directives
        ?.map(directive => GraphQLUtils.convertSchemaDirectiveToDirectiveConfig(directive))
        .filter(directive => !GRAPHQL_DIRECTIVES.includes(directive.name)) ?? [];
    const metaDirective = directives.find(d => d.name === 'meta');
    const metaFromDirective = metaDirective?.arguments ?? {};
    const baseMeta = { path: [], unmappedPath: [], ...metaFromDirective };
    switch (type.kind) {
        case 'SCALAR':
            return {
                kind: type.kind,
                typeName: type.name,
                isNullable,
                directives,
                meta: baseMeta,
                state: {},
            };
        case 'OBJECT':
            if (!('fields' in type)) {
                throw new Error('Object has no fields');
            }
            return DataTypeConfigU.createObjectDataTypeConfig({
                typeName: type.name,
                directives,
                meta: baseMeta,
                fields: type.fields.map(field => DataTypeConfigU.createFieldDataTypeConfig({
                    key: field.name,
                    description: field.description ?? undefined,
                    ofType: graphqlTypeToDefinition({
                        type: field.type,
                        rootTypes,
                        schema,
                    }),
                    args: field.args.map(arg => DataTypeConfigU.createInputValueDataTypeConfig({
                        key: arg.name,
                        defaultValue: arg.defaultValue,
                        ofType: graphqlTypeToDefinition({
                            type: arg.type,
                            rootTypes,
                            schema,
                        }),
                    })),
                })),
                isNullable,
            });
        case 'INPUT_OBJECT':
            if (!('inputFields' in type)) {
                throw new Error('Input object has no input fields');
            }
            return DataTypeConfigU.createInputObjectDataTypeConfig({
                typeName: type.name,
                isNullable,
                directives,
                meta: baseMeta,
                fields: type.inputFields.map(field => DataTypeConfigU.createInputValueDataTypeConfig({
                    key: field.name,
                    defaultValue: field.defaultValue,
                    ofType: graphqlTypeToDefinition({
                        type: field.type,
                        rootTypes,
                        schema,
                    }),
                })),
            });
        case 'UNION':
            if (!('possibleTypes' in type)) {
                throw new Error('Union has no possible types');
            }
            return DataTypeConfigU.createUnionDataTypeConfig({
                typeName: type.name,
                isNullable,
                directives,
                meta: baseMeta,
                possibleTypes: type.possibleTypes.map(possibleType => graphqlTypeToDefinition({
                    type: possibleType,
                    rootTypes,
                    schema,
                })),
            });
        case 'ENUM':
            const rootEnumType = (isRootType
                ? type
                : rootTypes.find(rootType => rootType.name === type.name));
            return DataTypeConfigU.createEnumDataTypeConfig({
                typeName: type.name,
                isNullable,
                directives,
                meta: baseMeta,
                enumValues: rootEnumType.enumValues.map(enumValue => DataTypeConfigU.createEnumValueDataTypeConfig({
                    name: enumValue.name,
                })),
            });
        case 'LIST':
            return DataTypeConfigU.createListDataTypeConfig({
                ofType: graphqlTypeToDefinition({
                    type: type.ofType,
                    rootTypes,
                    schema,
                }),
                isNullable,
            });
        case 'NON_NULL':
            return graphqlTypeToDefinition({
                type: type.ofType,
                rootTypes,
                isNullable: false,
                schema,
            });
        case 'INTERFACE':
        default:
            throw new Error(`Unknown type in GraphQL Schema: ${JSON.stringify(type.kind)}`);
    }
};
const isIgnoredType = (type) => {
    return type.kind === 'INTERFACE';
};
export const graphQLTypesToDefinitions = ({ introspectionTypes, schema, }) => {
    const definitions = introspectionTypes
        .filter(thing => !isIgnoredType(thing))
        .map(type => graphqlTypeToDefinition({
        type,
        rootTypes: introspectionTypes,
        isRootType: true,
        schema,
    }))
        .filter(item => !!item);
    return definitions;
};
export const schemaToDefinitions = (schemaSource) => graphQLTypesToDefinitions(introspectionToGraphQLTypes(schemaToIntrospection(schemaSource)));
//# sourceMappingURL=schemaToDefinitions.js.map